<template>
    <div
        :class="[
            'progress-small-orbs container',
            props.content.showBorder.value && 'progress-small-orbs--show-border',
        ]"
    >
        <div
            v-for="index in totalQuestions"
            :key="index"
            :class="[
                'progress-small-orbs__item',
                isChecked(index) && 'progress-small-orbs__item--checked',
            ]"
        />
    </div>
</template>

<script setup>
import { useStore } from 'vuex';
import {computed} from 'vue';
import { componentProps } from '../../../../../mixins/component/component';

const store = useStore();

const props = defineProps({
    ...componentProps,
    totalQuestionsOverwrite: {
        type: Number,
        default: null,
    },
    continuousFlowLength: {
        type: Number,
        default: null,
    },
});

const totalQuestions = computed(() => {
    if (props.totalQuestionsOverwrite) return props.totalQuestionsOverwrite;
    if (props.continuousFlowLength) return props.continuousFlowLength;
    return store.state.quiz.totalFlowLength;
});

const isChecked = index => {
    const isContinuousFlow = store.state.quiz.continuousFlow;

    if (isContinuousFlow) {
        const formStep = store.state.form.attributes.step;
        return index < store.state.quiz.questionCount + formStep - 1;
    }

    return index < store.state.quiz.questionCount;
};
</script>

<style lang="scss" scoped>
@use 'zoe-molecule-progress-small-orbs';

.progress-small-orbs {
    --background: v-bind('props.content.style.background.value');
    --orb-background: v-bind('props.content.style.orbBackground.value');
    --orb-active-background: v-bind('props.content.style.orbActiveBackground.value');
}
</style>
